/* eslint-disable no-unused-expressions */
// San Francisco Bounding box fallback
const SFDefault = {
    northLat: 37.8334643499866,
    southLat: 37.65972099481182,
    eastLng: -122.0841735127774,
    westLng: -122.86900932820708,
};

export const getBoundingRect = (
    userProperty,
    comparables,
) => {
    const boundingRect = {
        northLat: userProperty.lat,
        southLat: userProperty.lat,
        eastLng: userProperty.lon,
        westLng: userProperty.lon,
    };

    if (boundingRect.northLat === null) {
        boundingRect.northLat = SFDefault.northLat;
    }

    comparables &&
        comparables.forEach((comp) => {
            boundingRect.northLat =
                (boundingRect.northLat &&
                    comp.geo.lat &&
                    Math.max(boundingRect.northLat, comp.geo.lat)) ||
                SFDefault.northLat;
            boundingRect.southLat =
                (boundingRect.southLat &&
                    comp.geo.lat &&
                    Math.min(boundingRect.southLat, comp.geo.lat)) ||
                SFDefault.southLat;
            boundingRect.eastLng =
                (boundingRect.eastLng &&
                    comp.geo.lon &&
                    Math.max(boundingRect.eastLng, comp.geo.lon)) ||
                SFDefault.eastLng;
            boundingRect.westLng =
                (boundingRect.westLng &&
                    comp.geo.lon &&
                    Math.min(boundingRect.westLng, comp.geo.lon)) ||
                SFDefault.westLng;
        });
    return boundingRect;
};

export default getBoundingRect;
